/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: common.js
 */
(function ($, SCS) {
	'use strict';

	SCS.portal = SCS.portal || {};

	SCS.portal.emailRegExp = /^[^@]+([@]{1})[0-9a-zA-Z\\._-]+([\\.]{1})[0-9a-zA-Z\\._-]+$/;

	SCS.portal.lang = $('html').attr('lang'); // deprecated
	SCS.portal.i18n = {}; // deprecated

	/**
	 * APPLY AFTER EFFECTS:
	 * This method applies all after-effects.
	 * It styles drop-downs, checkboxes and radio buttons.
	 * It adds arrows to links.
	 * IMPORTANT: For each after-effect function it's important to remove the CSS class after the effect
	 * has been applied - this way, you can execute this function multiple times and don't break already
	 * created effects (necessary for authoring).
	 */
	SCS.portal.applyAfterEffects = function (componentName) {
		if (!window.CQ) {
			return;
		}
		var js = $('.authorstyling');
		var component = js.closest('.' + componentName);
		if (!component.length) {
			component = js.parent();
		}
		js.remove();
		js = null;
		SCS.ensure(component);
	};

	/**
	 * Prefill old forms from hash tags
	 * @deprecated
	 */
	SCS.portal.prefillFormFromHash = function () {
		var queryStringArray = location.hash.substr(1).split('&');
		var paramValueArray = {};
		if (queryStringArray) {
			for (var i = 0; i < queryStringArray.length; i += 1) {
				var paramValue = queryStringArray[i].split('=');
				paramValueArray[paramValue[0]] = paramValue[1];
			}
		}
		return paramValueArray;
	};

	/**
	 * Validate simple old form
	 * @param form Form
	 * @deprecated
	 */
	SCS.portal.validateSimpleForm = function (form) {
		var hasError = false;
		form.find('.headingError').hide();
		form.find('input:not([type=button]):not([type=submit]), textarea, select').each(function () {
			var row = $(this).closest('.field');
			row.removeClass('error');
			row.find('span.error').hide();
			row.find('input').removeClass('invalid invalid--inline').addClass('valid').removeAttr('style'); // SDX input field
		});
		form.find('input:not([type=button]):not([type=submit]), textarea, select').each(function () {
			var $this = $(this);
			var row = $this.closest('.field');
			var value = $this.val();
			var regexp = $this.data('regexp');
			if (value === '') {
				hasError = true;
				SCS.portal.showSimpleError(row);
			} else if (regexp && regexp !== '') {
				var valid = false;

				value = value.replace(/(\r\n|\n|\r)/gm, ' ');

				var t = (new RegExp(regexp, 'm')).exec(value);
				if (t) {
					var len = value.length;
					var pattlen = t[0].length;
					valid = (pattlen === len);
				}
				if (!valid) {
					hasError = true;
					SCS.portal.showSimpleError(row);
				}
			}
		});
		if (hasError) {
			form.find('.headingError').show();
		}
		return hasError;
	};

	SCS.portal.showSimpleError = function (row) {
		row.addClass('error');
		row.find('span.error').show();
		row.find('input').addClass('invalid invalid--inline'); // SDX input field
		if (window.debug) {
			window.debug.log('SCS.portal.showSimpleError', row.find('input').attr('name'));
		}
	};

	/**
	 * This function displays error messages in a dialog. If no parameter is passed to it, a general message is displayed.
	 */
	SCS.portal.showError = function (msg, title) {
		var debugMode = $('body').hasClass('cq_isPreviewMode') || $('body').hasClass('cq_isAuthorMode');
		if (!msg || !debugMode) {
			var generalErrorMessageData = $(document.body).data('generalErrorMessage');
				msg = generalErrorMessageData.length ? generalErrorMessageData : 'An unknown error occured.';
		}
		if (!title) {
			var generalErrorTitleData = $(document.body).data('generalErrorTitle');
			title = generalErrorTitleData.length ? generalErrorTitleData : 'Error';
		}
		$('<div>' + msg + '</div>').dialog({
			title: title,
			classes: {'ui-dialog': 'error'}
		});
	};

	/**
	 * Find teasers in different containers and synchronize their heights (based on sub-containers)
	 * (by default all predefined teasers are synched BUT one can define two parameters to only sync specific teasers)
	 */
	SCS.portal.synchronizeTeaserHeights = function (containerSelector, teaserSelector, scope) {
		// jshint loopfunc: true
		scope = scope ? scope : $('body');
		teaserSelector = containerSelector && teaserSelector && containerSelector.length && teaserSelector.length ?
			[[containerSelector, teaserSelector]] :
			[
				['.columncontainer', '.priceteaser'],
				['.columncontainer', '.alignedTeaser']
			];

		for (var n = 0; n < teaserSelector.length; n += 1) {
			scope.find(teaserSelector[n][0]).each(function () {
				var $ul = $(this);
				var $teaser = $ul.find(teaserSelector[n][1]);
				// find the teaser which has the most child elements
				var $refTeaser = $teaser.filter(':first');
				$teaser.each(function () {
					var $this = $(this);
					if ($this.children().length > $refTeaser.children().length) {
						$refTeaser = $this;
					}
				});
				var hiddenTeasers = $teaser.filter('.scs-accordion-tab-panel:hidden');
				var hiddenParents = $teaser.parents('.scs-accordion-tab-panel:hidden');
				hiddenTeasers.show();
				hiddenParents.show();
				$refTeaser.children().each(function (i) {
					i += 1;
					var $this = $(this);
					if (!$this.is('.clear')) {
						var height = 0;
						var nThChildren = $teaser.children(':nth-child(' + i + ')');
						if ($this.css('display') === 'inline') {
							nThChildren.css('display', 'block');
						}
						nThChildren.each(function () {
							var $this = $(this);
							// taagrma7: changed from height to min-height, since using height directly
							// would not allow us to decrease the size after the initial run, if we
							// remove some content dynamically. But we also want to respect any intialy
							// set height via inline styles, so we need to use another property.
							height = Math.max(height, $this.css('min-height', '').height());
						});
						nThChildren.css('min-height', height);
					}
				});
				hiddenParents.hide();
				hiddenTeasers.hide();
			});
		}
	};

	/**
	 * Synchronize heights of given node collection with the same logic as synchronizeTeaserHeights
	 * (means we synch the height of each and every child inside the nodes found in the collection)
	 */
	SCS.portal.synchronizeHeights = function ($teaser) {
		var nodes = [],
			$hiddens = $(),
			maxNodes = 0;

		var i, L, n;

		// do nothing with only one item
		if ($teaser.length < 2) { return; }

		for (i = 0, L = $teaser.length; i < L; i+=1) {
			var $children = $teaser.eq(i).children();
			if ($children.length) {
				nodes.push($children);
			}
			if (maxNodes < $children.length) {
				maxNodes = $children.length;
			}
		}

		// process all parents (including ourself)
		var $parents = $teaser.add($teaser.parents());
		// find and show all hiddent parent nodes
		// needed to measure the actual node height
		for (i = 0, L = $parents.length; i < L; i+=1) {
			// get the parent jquery node
			var $parent = $parents.eq(i);
			// only process items with hide declaration
			if ($parent.css('display') === 'none') {
				// store old style attribute to restore it later
				$parent.data('old-display', $parent.attr('display') || '');
				$parent.data('old-style', $parent.attr('style') || '');
				// show the child and add to array for later
				$hiddens = $hiddens.add($parent.css('display', 'block'));
			}
		}

		for (i = 0; i < maxNodes; i+=1) {
			var maxHeight = 0;
			for (n = 0; n < nodes.length; n+=1) {
				if (nodes[n].length < i) {
					continue;
				}
				var $node = nodes[n].eq(i);
				$node.css('min-height', '');
				var height = $node.height();
				if (height > maxHeight) {
					maxHeight = height;
				}
			}
			if (!maxHeight) {
				continue;
			}
			for (n = 0; n < nodes.length; n+=1) {
				if (nodes[n].length >= i) {
					nodes[n].eq(i).css('min-height', maxHeight);
				}
			}
		}

		// hide everything again (use previous display value)
		for (i = 0, L = $hiddens.length; i < L; i+=1) {
			var $hidden = $hiddens.eq(i);
			// may has only been hidden by class and not inline styles
			$hidden.css('display', $hidden.data('old-display'))
				.attr('style', $hidden.data('old-style'));
		}
	};

	/**
	 * Initialize paging
	 * @param nextButton Next button
	 * @param items Items
	 */
	SCS.portal.initPaging = function (nextButton, items) {
		if (nextButton.length > 0 && items.length > 0) {
			var itemsPerPage = parseInt(nextButton.data('items-per-page'), 10);
			if (itemsPerPage === -1 || items.length === itemsPerPage) {
				return; // break if all items should be displayed
			}

			// if the next page already shows all items
			if (itemsPerPage + itemsPerPage >= items.length) {
				nextButton.val(nextButton.data('button-text-all'));
			}

			nextButton.click(function () {
				var $this = $(this);
				items.filter(':hidden').filter(':lt(' + itemsPerPage + ')').show();
				if (items.filter(':hidden').length <= 0) {
					nextButton.parent().hide();
				}
				else if (items.filter(':visible').length + itemsPerPage >= items.length) {
					$this.val($this.data('button-text-all'));
				}
			});
		}
	};

	/**
	 * Initialize image maps tool tips (call outs)
	 */
	SCS.portal.initImageMapCallouts = function () {
		$('.imageContainer img, area').qtip();
	};

	SCS.portal.tplToString = function (tplEl) {
		return $(tplEl).wrap('<span />').parent().html();
	};

	/**
	 * Initialize common stuff
	 */

	/* Repeated inits (using ensure) */

	// Apply custom input (radio buttons and checkboxes) styling
	SCS.ensure(function (context) {
		// the customInput function is already safe to execute multiple times
		context.find('input[type=checkbox]:not(.sdx), input[type=radio]:not(.sdx)').customInput();
	});

	// Apply drop down after effects
	SCS.ensure(function (context) {
		context.find('.customDropDown').sSelect();
	});

	// FIXME: still used?
	// Apply media player stuff
	SCS.ensure(function (context, $) {
		context.find('.scs-media-player').each(function () {
			var staticImage = $(this).find('.scs-media-player-content img');
			var staticImageSrc = staticImage.attr('src');
			if (staticImageSrc && staticImageSrc.match(/^[/][/]/)) {
				// add the current pages protocol, as workaround for a jwplayer bug
				var protocol = location.href.match(/^https?/);
				staticImage.attr('src', protocol + ':' + staticImageSrc);
			}
			$(this).mediaPlayer();
		});
	});

	// Apply arrows on links
	SCS.ensure(function (context) {
		// wrap links with div
		var links = context.find('a.arrow')
			.add(context.find('a').has('span.alternative-action-link', 'span.alternative-action-link-large', 'span.arrowLink'))
			.add(context.find('span.alternative-action-link a', 'span.alternative-action-link-large a', 'span.arrowLink a'));

		links.removeClass('arrow').wrap('<div class="scs-primary-link" />');
		context.find('span.alternative-action-link').removeClass('alternative-action-link');
		context.find('span.alternative-action-link-large').removeClass('alternative-action-link-large').addClass('action-link-large');
		context.find('span.arrowLink').removeClass('arrowLink');
	});

	// FIXME: still used? replace with modern CSS
	// Initialize definition lists
	SCS.ensure(function (context) {
		// set a class on the first dt and dd pair in the list
		context.find('dl').find('dt:first, dd:first').addClass('first-child');
	}, 'body, .ui-tabs-panel, .ui-dialog-content');

	// @deprecated
	// Prefill old forms from cookies or hash
	SCS.ensure(function (context, $) {
		$('form', context).has('input[name=":formid"]').each(function () {
			var $form = $(this),
				formName = $form.find('input[name=":formid"]').val(),
				prefillCookie = $.parseJSON($.cookie('SCSPrefillForm_' + formName) || 'null'),
				prefillFields = prefillCookie;

			if (!prefillFields && !$form.parent().hasClass('modScForm')) {
				// try to read from the request (with hash tag)
				prefillFields = SCS.portal.prefillFormFromHash();
			}

			if (prefillFields) {
				$.each(prefillFields, function (idx, val) {
					$('[name="' + idx + '"]', $form).val(val).trigger('change');
				});
			}

			if (prefillCookie) {
				// Clear the cookie
				$.cookie('SCSPrefillForm_' + formName, null, {path: '/', domain: '.swisscom.ch'});
			}
		});
	}, 'body, .ui-tabs-panel, .ui-dialog-content');


	// Initialize "Link target: Lightbox" links with HTML page inside
	var openLightbox = function (event) {
		event.preventDefault();
		var $this = $(this),
			url = $this.attr('href'),
			// default: 600x400 ; minimal: 300x100
			lightboxWidth = Math.max($this.data('lightbox-width') || 600, 300),
			lightboxHeight = Math.max($this.data('lightbox-height') || 400, 100),
			classname = '',
			lightboxClosed = function () {
				window.SCS.HashDeepLink.set('lightbox');
				$this.focus(); // restore focus after closing the lightbox
			},
			isExternalUrl = SCS.utils.isExternalUrl && SCS.utils.isExternalUrl(url);

		// allow deeplinking to this lightbox (for opening the deeplinks search for "##jumpMarker-lightboxDeeplinkOpen##" in the code)
		window.SCS.HashDeepLink.set('lightbox', 'sel:[target="lightbox"][href="' + url + '"]');

		//only the content without header and footer, also skip stage by showing first parsys only
		// in case the link has a print selector the link is shown in an iframe
		if (!isExternalUrl && !url.match(/\.print\./)) {
			$.get(url, function (data) {
				var $html = $(data);
				var titleSelectors = ['.content h1', '.modTitle', '#scs-pagetitle'];
				// Detach the content first so that we only search for the title in parts of the DOM that are not included
				var $content = $html.find('.content > div.parsys').detach();
				var $title;
				for(var i = 0; i < titleSelectors.length; i += 1) {
					var sel = titleSelectors[i]+':first';
					$title = $html.filter(sel).add($html.find(sel)).first();
					if($title.length) {
						break;
					}
				}
				var title = $.trim($title.text());

				// reconstruct page structure because a lot of css is based on that
				$content = $content.wrap('<div class="middle fake"><div class="content fake" /></div>');

				// create and open dialog
				$content.addClass('ui-dialog-lightbox-content').dialog({
					classes: {'ui-dialog': 'ui-dialog-lightbox' + (title === '' ? ' no-title' : '')},
					width: lightboxWidth,
					height: lightboxHeight,
					title: title,
					open: function () {
						// initialize newly added content, override selector-specific ensure listeners
						SCS.ensure($content, false);
						// adjust carousel arrows when brightcove players are initialized
						$content.on('brightcove.playerloaded', function () {
							$content.find('.carouselContainer').each(function () {
								SCS.carousel.adjustArrowNavigationPosition($(this).scCarousel());
							});
						});

						// jshint camelcase: false
						// OSO-464 automatic overlay tracking
						if (SCS.portal && SCS.portal.datalayer && SCS.portal.datalayer.pushPagePath) {
							var href = $this.attr('href'),
								name = href.substr(href.lastIndexOf('/')),
								overlayName = name.split('/').pop().replace('.html', '');
							SCS.portal.datalayer.pushPagePath(overlayName);
							SCS.portal.datalayer.trackPageView();
							SCS.portal.datalayer.popPagePath();
						}
					},
					close: function () {
						$('.ui-dialog-lightbox-content').remove();
						lightboxClosed();
					}
				});
			});
		} else {
			$.colorbox({
				href: url,
				iframe: true,
				width: lightboxWidth,
				height: lightboxHeight,
				className: classname,
				onClosed: lightboxClosed
			});
		}
	};
	SCS.ensure(function (context) {
		context.find('a[target="lightbox"]:not([data-handler-attached])').on('click', openLightbox).attr('data-handler-attached', 'true');
	}, 'body, .ui-tabs-panel, .ui-dialog-content, .modTabNavigationContent');


	// empty all hrefs on a page when using the .nolinks selector or #nolinks hash
	(function () {
		var
			path = document.location.pathname.split('/'),
			pageName = path[path.length - 1];

		if((window.location.hash.search('nolinks') !== -1) || (pageName.search('.nolinks') !== -1)) {
			SCS.ensure(function($ctx) {
				// jshint scripturl: true
				$ctx.find('*[href]').attr('href', 'javascript:;');
			});
		}
	})();

	/* One-time inits (on load) */

	$(window).on('load', function() {
		// synch teaser heights when the window is loaded because images without fix height could make a resizeing of the teasers necessary
		SCS.portal.synchronizeTeaserHeights();
		$('body').trigger('sync-heights');
	});

	/* One-time inits (on ready) */

	$(document).ready(function () {
		SCS.portal.initImageMapCallouts();

		// developmental feature: add “&wcmmode=disabled&endless” to your URL will make navigation on the website easier in author-mode
		var $body = $(document.body), hasEndless, isMobile;
		function addEndlessToLinks(context, $) {
			context.find('a[href]:not([href^="http"]):not([href^="javascript:"]):not([href^="#"]):not([href^="mailto:"])').each(function () {
				var $a = $(this);
				if(hasEndless && $a.attr('href').indexOf('&endless') === -1) {
					$a.attr('href', SCS.portal.addParamToUrl($a.attr('href'), 'wcmmode', 'disabled', 'endless', null));
				}
				if(isMobile && $a.attr('href').indexOf('.mobile.html') === -1) {
					$a.attr('href', $a.attr('href').replace('.html', '.mobile.html'));
				}
			});
		}
		if($body.is('.cq_isAuthorInstance') && ($body.is('.cq_isPreviewMode') || $body.is('.cq_isPublishMode'))) {
			hasEndless = window.location.href.indexOf('&endless') > 0;
			isMobile = $('body').is('.is-mobile');
			if(hasEndless || isMobile) {
				SCS.ensure(addEndlessToLinks);
				addEndlessToLinks($body, $);
			}
		}
	});

	/* Overwrite stuff */

	// Overwrite zIndex() function of jQuery to work around crappy implementation of the jQuery.UI.Dialog
	(function () {
		var originalFunction = $.fn.zIndex;

		$.fn.zIndex = function () {
			var value = originalFunction.apply(this, arguments),
				dialogContent = this.closest('.ui-dialog-content'),
				dialogContentZindex = (dialogContent.length ? originalFunction.call(dialogContent) : 0);

			if (dialogContent.length && !isNaN(value) && value < dialogContentZindex) {
				value += dialogContentZindex;
			}

			return value;
		};
	})();
})(window.Tc.$, window.SCS = window.SCS || {});



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/common.js
// module id = 112
// module chunks = 0